import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to format USP (Unique Selling Points) strings or arrays
 * Handles both string and string[] inputs
 * Fixes spacing issues where commas have space before instead of after
 */
@Pipe({
  name: 'uspFormatting',
  standalone: true,
})
export class UspFormattingPipe implements PipeTransform {
  transform(value: string | string[] | null | undefined): string {
    if (!value) {
      return '';
    }

    // If it's an array, join with proper comma spacing
    if (Array.isArray(value)) {
      return value.join(', ');
    }

    // If it's a string, normalize comma spacing
    return value.replace(/\s*,\s*/g, ', ').trim();
  }
}
